import {Tooltip} from '@material-ui/core';
import {withStyles} from '@material-ui/styles';
import React from 'react';
export const ErrorTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'red',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

export const ErrorWithTooltip = ({children, error}) => {
  return error ? <ErrorTooltip title={error}>{children}</ErrorTooltip> : children;
};
